import type { DefaultTheme } from 'styled-components/macro';
import styled from 'styled-components/macro';

import Button from 'components/Button/Button';
import FlexContainer from 'components/FlexContainer/FlexContainer';
import { CloseButtonIconStyled } from 'components/Popup/Popup.styled';

/** Content area fills the modal; white background to match ticket view cards. */
export const getPopupContentStyle = (
  theme: DefaultTheme,
  _isMobile: boolean,
  _isTablet: boolean,
  _isDesktop: boolean,
  _isLargeDesktop: boolean
): Record<string, string> => ({
  width: '100%',
  minHeight: '0',
  display: 'flex',
  flexDirection: 'column',
  padding: '0',
  backgroundColor: theme.colors.surface,
});

/** Outer wrapper: fills modal, column layout, scrollable body. */
export const NewTicketPopupContentWrapStyled = styled(FlexContainer)`
  width: 100%;
  height: 100%;
  min-height: 0;
  flex-direction: column;
  align-items: stretch;
`;

/** Scrollable form area: takes remaining space, scrolls when needed. */
export const NewTicketPopupScrollWrapStyled = styled.div`
  flex: 1 1 0;
  min-height: 0;
  overflow-y: auto;
  overflow-x: hidden;
  width: 100%;
  padding: 1rem 1.5rem 2rem;
  box-sizing: border-box;
`;

export const FormStyled = styled.form`
  display: flex;
  flex-direction: column;
  flex: 1 1 0;
  min-height: 0;
  width: 100%;
  max-width: 100%;
  min-width: 0;
`;

export const FlexContainerMessageStyled = styled(FlexContainer)`
  ${({ theme }): string => `
    ${theme.devices.tablet} {
      padding: 0 2.5rem 0.625rem;
    }
  `}
`;

export const AddCategoryLineBtnStyled = styled(Button)`
  padding: 0.5rem;
  margin: 0 0 1rem;
  height: 24px;

  span {
    margin-right: 0;
  }
`;

export const CloseButtonStyled = styled(CloseButtonIconStyled)`
  top: 32px;
  right: -24px;
`;
